import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function CornerSVG({ classNameProps }: PropsTypeSvg) {
  return (
    <svg
      className={classNameProps}
      viewBox='0 0 16 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 0V10.9352C0 12.7711 2.21964 13.6905 3.51779 12.3923L16 0H0Z'
        className='fill-green'
      />
    </svg>
  );
}

export default CornerSVG;
